import { Avatar, AvatarProps, Modal, Box, IconButton } from "@mui/material";
import { useState, useEffect } from "react";

type Props = {
    src: string;
    fallbackSrc: string;
} & AvatarProps;

export const AvatarWithFallback = (props: Props) => {
    const [src, setSrc] = useState(props.src);
    const [open, setOpen] = useState(false);
    const [pushedToHistory, setPushedToHistory] = useState(false);

    useEffect(() => {
        const img = new Image();
        img.src = src;
        img.onerror = () => setSrc(props.fallbackSrc);
    }, [src, props.fallbackSrc]);

    // Hantera tillbaka-knapp
    useEffect(() => {
        const handlePopState = () => {
            if (pushedToHistory) {
                setOpen(false);
                setPushedToHistory(false);
            }
        };

        window.addEventListener("popstate", handlePopState);
        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [pushedToHistory]);

    const handleOpen = () => {
        // add a new history state if the user chooses to later close the modal with the back in the browser.
        window.history.pushState({ modal: true }, "");
        setPushedToHistory(true);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        if (pushedToHistory) {
            window.history.back();
        }
    };

    return (
        <>
            <IconButton onClick={handleOpen}>
                <Avatar alt="No" src={src} variant="square" sx={{ width: 48, height: 48 }} />
            </IconButton>
            <Modal open={open} onClose={handleClose}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "80%",
                        height: "60%",
                    }}
                >
                    <img
                        src={src.replace("small", "large")}
                        alt="Expanded"
                        style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            display: "block",
                            margin: "0 auto",
                            cursor: "pointer",
                        }}
                        onClick={handleClose}
                    />
                </Box>
            </Modal>
        </>
    );
};
